import { EventEndpoints, PaginatedResponse, SiteControlEvent } from '@scaleaq/sitecontrol-lib';

import { API_NAMES, CACHE_KEYS } from '@/constants';
import { useAuthApiGetSingleFetch } from '@/dataAccess/rest/apiHooks';

import { paginatedEventsParamsToQueryString } from './event_datahook/paginatedEventsParamsToQueryString.ts';
import { UsePaginatedEventsParams } from './events.types.ts';

export const useEvent = (id: string) => {
  return useAuthApiGetSingleFetch<SiteControlEvent>({
    baseApiRoute: API_NAMES.eventApi,
    route: EventEndpoints.getEventById.replace('{id}', id),
    cacheKeys: [CACHE_KEYS.events, id && id.trim() !== '' ? id : ''],
  });
};

export const usePaginatedEvents = ({
  eventQueryOptions,
  paginationQuery,
}: UsePaginatedEventsParams) => {
  const cacheKeys = [
    `usePaginatedEvents`,
    `${paginationQuery.page}`,
    `${paginationQuery.pageSize}`,
    `${eventQueryOptions.endTime}`,
    `${eventQueryOptions.eventType}`,
    `${eventQueryOptions.inventoryId}`,
    `${eventQueryOptions.sortDirection}`,
    `${eventQueryOptions.startTime}`,
  ];
  const queryString = paginatedEventsParamsToQueryString({ eventQueryOptions, paginationQuery });
  return useAuthApiGetSingleFetch<PaginatedResponse<SiteControlEvent>>({
    baseApiRoute: API_NAMES.eventApi,
    route: `${EventEndpoints.publishEvent}?${queryString}`,
    cacheKeys,
  });
};
